import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { BrushContext } from '../EventsTrackers/BrushTracker';
import { useChartData } from '../context/ChartContext';
import { options } from '../toolbar/ToolTypes';
const styles = {
    container: {
        transformOrigin: 'top left',
        position: 'absolute',
        top: '0px',
        left: '0px',
        zoom: '100%',
    },
};
const allowTools = new Set([
    options.zoom.id,
    options.apodization.id,
    options.zeroFilling.id,
    options.peakPicking.id,
    options.integral.id,
    options.phaseCorrection.id,
    options.baselineCorrection.id,
    options.rangePicking.id,
    options.zonePicking.id,
    options.slicing.id,
    options.editRange.id,
    options.multipleSpectraAnalysis.id,
    options.exclusionZones.id,
    options.databaseRangesSelection.id,
]);
export const BRUSH_TYPE = {
    X: 1,
    Y: 2,
    XY: 3,
};
const defaultDimensionBorder = {
    startX: 0,
    startY: 0,
};
export default function BrushXY({ brushType = BRUSH_TYPE.XY, dimensionBorder = defaultDimensionBorder, width: widthProps, height: heightProps, }) {
    let { width, height, toolOptions: { selectedTool }, } = useChartData();
    let { startX, endX, startY, endY, step } = useContext(BrushContext);
    if (!allowTools.has(selectedTool) ||
        step !== 'brushing' ||
        !dimensionBorder ||
        (dimensionBorder.startX && startX < dimensionBorder.startX) ||
        (dimensionBorder.startY && startY < dimensionBorder.startY) ||
        ((dimensionBorder.endX && Math.sign(endX - startX) === 1
            ? endX > dimensionBorder.endX
            : endX < dimensionBorder.startX) &&
            (dimensionBorder.endX &&
                dimensionBorder.endY &&
                Math.sign(endY - startY) === 1
                ? endY > dimensionBorder.endY
                : endY < dimensionBorder.startY))) {
        return null;
    }
    width = widthProps || width;
    height = heightProps || height;
    endX =
        dimensionBorder.endX && endX > dimensionBorder.endX
            ? dimensionBorder.endX
            : dimensionBorder.startX && endX < dimensionBorder.startX
                ? dimensionBorder.startX
                : endX;
    endY =
        dimensionBorder.endY && endY > dimensionBorder.endY
            ? dimensionBorder.endY
            : dimensionBorder.startY && endY < dimensionBorder.startY
                ? dimensionBorder.startY
                : endY;
    const scaleX = brushType === BRUSH_TYPE.X || brushType === BRUSH_TYPE.XY
        ? (endX - startX) / width
        : 1;
    startX =
        brushType === BRUSH_TYPE.X || brushType === BRUSH_TYPE.XY ? startX : 0;
    const scaleY = brushType === BRUSH_TYPE.Y || brushType === BRUSH_TYPE.XY
        ? (endY - startY) / height
        : 1;
    startY =
        brushType === BRUSH_TYPE.Y || brushType === BRUSH_TYPE.XY ? startY : 0;
    return (_jsx("div", { style: {
            ...styles.container,
            transform: `translate(${startX}px, ${startY}px) scale(${scaleX},${scaleY})`,
            willChange: 'transform',
        }, children: _jsx("svg", { width: width, height: height, children: _jsx("rect", { x: "0", y: "0", width: width, height: height, fill: "gray", opacity: "0.2" }) }) }));
}
